import React, { useEffect } from 'react';
import InbankBanner from '../../../images/inbank_banner_uus.svg';
import InbankMakseviis from '../../../images/inbank_makseviis_mobile_uus.svg';
// import InbankTaotlemine from '../../../images/inbank_taotlemine_mobile.svg';
import Makseviis from '../../../images/inbank_makseviis_uus.svg';
// import Taotlemine from '../../../images/inbank_taotlemine.svg';
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

export default function Inbank() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    if (window.history.length > 2) {
      window.history.back();
    } else {
      navigate('/');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="my-4 lg:my-12 md:max-w-2xl lg:max-w-4xl">
        <div className="md:mb-10">
          <button
            className="hidden md:flex md:w-32 py-2 px-4 bg-rgreen text-white rounded-sm md:items-center md:mr-auto"
            type="button"
            onClick={handleBack}
            aria-label="Tagasi"
          >
            <ChevronLeftIcon className="w-5 h-5 m-1" aria-hidden="true" />
            <span className="text-sm mx-2">Tagasi</span>
          </button>
        </div>
        <div className="flex flex-col items-center justify-center">
          <div className="md:bg-rgrey-lightborder md:rounded-lg md:p-6">
            <img
              src={InbankBanner}
              alt="Inbank"
              className="w-full h-auto object-cover rounded-2xl"
              aria-label="Inbank"
            />
            <div className="my-10 md:my-16 md:px-6 lg:px-16">
              <div className="text-4xl font-axi-bold mb-5 md:mb-6">
                Inbanki makseviisid
              </div>
              <div className="text-base mb-4 md:mb-5">
                Inbanki makseviisid aitavad ostude eest veelgi mugavamalt
                tasuda. Tasu oma ostu eest alles järgmisel kuul või jaga
                ostusumma kolmeks/kuueks võrdseks osaks, lihtsalt ja ilma ühegi
                lisatasuta. Leia sobiv makselahendus kassast ja vali endale
                sobivaim järgmistest valikutest.
              </div>
              <div className="text-base font-axi-bold mb-3 mb:mb-4">
                Inbank maksa järgmisel kuul:
              </div>
              <div className="ml-3 mb-4 md:mb-5">
                <ul className="text-base mx-4 space-y-2 list-disc">
                  <li>Maksa järgmisel kuul</li>
                  <li>30 – 800 € ostudele</li>
                  <li>0 € lisatasu</li>
                </ul>
              </div>
              <div className="text-base font-axi-bold mb-3 mb:mb-4">
                Inbank maksa 3 võrdses osas:
              </div>
              <div className="ml-3 mb-4 md:mb-5">
                <ul className="text-base mx-4 space-y-2 list-disc">
                  <li>Maksa 3 võrdses osas</li>
                  <li>100 – 2500 € ostudele</li>
                  <li>0 € lisatasu</li>
                </ul>
              </div>
              <div className="text-base font-axi-bold mb-3 mb:mb-4">
                Inbank maksa 6 võrdses osas:
              </div>
              <div className="ml-3 mb-7 md:mb-9">
                <ul className="text-base mx-4 space-y-2 list-disc">
                  <li>Maksa 6 võrdses osas</li>
                  <li>175 – 2500 € ostudele</li>
                  <li>0 € lisatasu</li>
                </ul>
              </div>
              <div className="text-2xl font-axi-bold mb-3 md:mb-4">
                Miks valida Inbanki makseviis?
              </div>
              <div className="ml-3 mb-8 md:mb-9">
                <ul className="text-base mx-4 space-y-2 list-disc">
                  <li>
                    Lihtne ja lisatasudeta - pole intressi, lepingutasu ega
                    igakuist haldustasu.
                  </li>
                  <li>
                    Nutikas viis soetada kohe kõik, mida vajad, tegemata
                    valikute arvelt järeleandmisi. Maksmist alustad alles
                    järgmisel kuul.
                  </li>
                  <li>
                    Inbanki maksa hiljem makseviiside puhul ei ole tegu
                    järelmaksuga, vaid krediidivabade makseviisidega.
                  </li>
                </ul>
              </div>
              <div className="text-2xl font-axi-bold mb-4 md:mb-5">
                Inbanki makseviisiga tasumine on lihtne!
              </div>
              <img
                src={InbankMakseviis}
                alt="Inbank makseviisiga tasumine"
                className="w-56 md:hidden h-auto object-cover rounded-lg mb-7"
                aria-label="Inbank makseviisiga tasumine"
              />
              <img
                src={Makseviis}
                alt="Inbank makseviisiga tasumine"
                className="hidden md:block md:w-full h-auto object-cover rounded-lg mb-9"
                aria-label="Inbank makseviisiga tasumine"
              />
              <div className="mb-8 md:mb-16">
                <p className="text-base mb-2">
                  Ost kinnitatakse vaid mõne hetkega.
                </p>
                <p className="text-base mb-2">
                  Küsimuste korral võta ühendust Inbanki klienditoega aadressil
                  <a href="mailto:info@inbank.ee" className="px-1 underline">
                    info@inbank.ee
                  </a>{' '}
                  või helista{' '}
                  <a href="tel:+3726408080" className="px-1 underline">
                    +372 640 8080
                  </a>
                  .
                </p>
              </div>
              <div>
                <button
                  className="md:hidden w-full py-2 px-4 bg-rgreen text-white rounded-sm flex items-center justify-center"
                  type="button"
                  onClick={handleBack}
                  aria-label="Tagasi"
                >
                  <ChevronLeftIcon className="w-5 h-5 m-1" aria-hidden="true" />
                  <span className="text-sm mx-2">Tagasi</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
